import styled from 'styled-components';
import ModifiedDropdown from './elements/ModifiedDropdown';

export const Dropdown = styled(ModifiedDropdown)`
  &&&&&& [role='option'],
  &&&&&& .text[role='alert'] {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }
`;
